import ScrollReveal from 'stimulus-scroll-reveal'

// Connects to data-controller="scroll-reveal"
export default class extends ScrollReveal {
  connect() {
    document.querySelectorAll('.reveal').forEach(item => (item.dataset.scrollRevealTarget = 'item'))
    super.connect()
  }
}
